import SuperFetch from 'library/helpers/superFetch';
import React, { Fragment, useState } from 'react';
import { Notification } from 'zComponents/atoms';
import { Button, Modal, Typography } from 'zui/Antd';
import { ConditionalTooltipButton } from 'zui/Custom';

const { Text } = Typography;

const RevokePersonPermissionModal = ({
	children,
	data,
	setPermissionStateUpdate,
	revokePermission,
	revokeAllPermissions
}) => {
	const { entity } = data;
	const [loading, setLoading] = useState(false);
	const [confirmModalVisible, setConfirmModalVisible] = useState(false);

	const handleRevokePermission = async () => {
		setLoading(true);
		let res;
		if (revokePermission) {
			res = await SuperFetch.post('/access/revokePermission', {
				permissionTypeID: entity.permissionTypeID,
				...(entity.teamIDs ? { teamIDs: [entity.teamIDs] } : null),
				...(entity.personIDs ? { personIDs: [entity.personIDs] } : null),
				...(entity.deviceID ? { deviceIDs: [entity.deviceID] } : null),
				...(entity.assetGroupID ? { assetGroupIDs: [entity.assetGroupID] } : null)
			});
		} else {
			res = await SuperFetch.post('/access/revokePermissionByIDs', {
				permissionIDs: entity.permissionIDs
			});
		}
		if (res.statusCode === 200) {
			Notification('success', 'Permission Revoked Successfully.');
			setPermissionStateUpdate(true);
		} else {
			Notification('error', 'Error Revoking Permission.');
		}
		setConfirmModalVisible(false);
		setLoading(false);
	};
	return (
		<Fragment>
			<ConditionalTooltipButton
				buttonText={`Revoke${revokeAllPermissions ? ' All' : ''}`}
				condition={false}
				disabledCondition={false}
				trueTitle={''}
				falseTitle={''}
				onClick={() => setConfirmModalVisible(true)}
				danger={true}
			>
				{children}
			</ConditionalTooltipButton>

			<Modal
				title={`Confirm Revoke Permission`}
				danger
				width={700}
				open={confirmModalVisible}
				onCancel={() => setConfirmModalVisible(false)}
				destroyOnClose={true}
				footer={[
					<Button key='cancel' onClick={() => setConfirmModalVisible(false)}>
						Cancel
					</Button>,
					<Button loading={loading} key='delete' danger onClick={() => handleRevokePermission()}>
						Revoke
					</Button>
				]}
				style={{ textAlign: 'center' }}
			>
				<Text>
					Are you sure you want to revoke {revokeAllPermissions ? 'all of ' : ' '}
					<span style={{ fontWeight: '600', color: '#FF5B58' }}>{entity.permissionNameOwner}</span>
					's permission for <span style={{ fontWeight: '600', color: '#FF5B58' }}> {entity.name}</span>?
				</Text>
			</Modal>
		</Fragment>
	);
};

export default RevokePersonPermissionModal;
